@let hasStore = !!store;
@let hasOpportunity = !!opportunity;
<div class="relative top-4 z-50 mx-auto w-[276px] max-w-sm -translate-x-1/2 font-sans text-base">
  <div class="absolute -top-3 left-1/2 size-6 -translate-x-1/2 rotate-45 bg-gray-light"></div>
  <div class="drop-shadow-custom rounded-3xl bg-gray-light p-4">
    @if (hasStore) {
      @if (store.brandAndStore; as brandAndStore) {
        <div class="flex flex-col items-center gap-y-1.5 pb-3 font-title text-[22px]">
          <span>{{ brandAndStore[0] }}</span>
          <span>{{ brandAndStore[1] }}</span>
        </div>
      }
      <div class="flex flex-col items-center gap-y-2 pb-3">
        @if (store.url) {
          @if (hasAppointmentCta()) {
            <app-button
              (onButtonClick)="emitGtmEvent()"
              [label]="'COMPONENT.STORE-LOCATOR.SELECT_THIS_STORE' | translate"
              [url]="store.url" />
          } @else {
            <app-button
              (onButtonClick)="onStoreAppointmentClick(true)"
              [label]="'COMPONENT.STORE-LOCATOR.SELECT_THIS_STORE' | translate" />
          }
        }
        @if (hasAppointmentCta()) {
          <app-button
            (onButtonClick)="onStoreAppointmentClick()"
            [label]="'COMPONENT.STORE-LOCATOR.BOOK_APPOINTMENT' | translate"
            theme="WHITE" />
        }
      </div>
      <div class="grid grid-cols-[27px_auto] items-center gap-2">
        <app-svg [height]="27" class="justify-self-center" src="assets/icons/pin.svg" />
        <div class="flex flex-col font-bold">
          <span>{{ store.streetName }}</span>
          <span>{{ store.zipcode }} {{ store.city }}</span>
        </div>
        <app-svg [height]="22" [width]="22" class="justify-self-center" src="assets/icons/phone.svg" />
        <div class="font-bold">
          @if (store.phone) {
            <a [href]="store.phone.telLink">
              {{ store.phone.formatted }}
            </a>
          }
        </div>
        @let status = storeStatus();
        @let opStatus = operationalStatus();
        @if (status) {
          <app-svg [height]="18" [width]="18" class="justify-self-center" src="assets/icons/hour.svg" />
          <div class="flex flex-col">
            <span class="font-bold">
              @if (opStatus) {
                {{ opStatus.message }}
              } @else if (status.isOpenToday) {
                {{ "GLOBAL.STORE_OPEN_TODAY" | translate }}
              } @else {
                {{ "GLOBAL.STORE_CLOSED_TODAY" | translate }}
              }
            </span>
            @if (status.isOpenToday && status.hoursToday && !opStatus) {
              <span>
                {{ status.hoursToday }}
              </span>
            }
          </div>
        }
      </div>
    } @else if (hasOpportunity) {
      <div class="flex flex-col items-center">
        <div class="pb-3 text-center font-title text-[22px]">{{ opportunity.name }}</div>
        <div class="pb-5 text-center text-[14px]">
          {{ "COMPONENT.MAP-POPIN.WANT_TO_KNOW_MORE_OPPORTUNITY" | translate }}
        </div>
        <app-button [label]="'GLOBAL.CONTACT_US' | translate" [url]="opportunityContactUrl()" />
      </div>
    }
  </div>
</div>
